import { $api } from "@/shared/api";
import { useConnectionState } from "@/shared/realtime";

import { isClipWorking } from "../model/clipState";
import { overviewItems } from "../model/overviewItems";
import { HIGHLIGHTS_POLL_INTERVAL_MS } from "./HIGHLIGHTS_POLL_INTERVAL_MS";
import { useHighlightsAllowed } from "./useHighlightsAllowed";

// Раздел «Хайлайты» (`GET /api/highlights`): матчи с моментами и готовые клипы. Его же читают
// полоса на главной и значки в списке матчей. `matchId` — матч, к которому пришли из разбора:
// сервер добавит его, даже если он старше последних (свой кэш). Клип в работе, а соединения
// нет — перечитываем сами; с соединением обновит `highlights.updated`. Хайлайты закрыты для
// игрока — запроса нет.
export const useHighlightsOverview = (matchId?: number) => {
  const connection = useConnectionState();
  const allowed = useHighlightsAllowed();
  const init = matchId === undefined ? undefined : { params: { query: { match: matchId } } };
  return $api.useQuery("get", "/api/highlights", init, {
    enabled: allowed,
    refetchInterval: ({ state }) =>
      connection !== "connected" &&
      state.data !== undefined &&
      overviewItems(state.data).some(isClipWorking)
        ? HIGHLIGHTS_POLL_INTERVAL_MS
        : false,
  });
};
